import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const LoaderContainer = styled.div`
  width: ${rem(320)};
  height: ${rem(444)};
  display: flex;
  flex-direction: column;
`

const ImageLoadingBox = styled(LoadingBox)`
    height: ${rem(200)};
`

const TagsLoadingBox = styled(LoadingBox)`
    height: ${rem(18)};
    width: ${rem(143)};
    margin-top: ${rem(20)};
`

const ReviewsLoadingBox = styled(LoadingBox)`
    height: ${rem(16)};
    width: ${rem(164)};
`

const PricingLoadingBoxTop = styled(LoadingBox)`
    height: ${rem(18)};
    width: ${rem(132)};
`

const PricingLoadingBoxBottom = styled(LoadingBox)`
    height: ${rem(18)};
    width: ${rem(128)};
    margin-top: ${rem(4)};
`

const ViewButtonLoadingBox = styled(LoadingBox)`
    height: ${rem(40)};
    width: ${rem(80)};
`

export const CarouselCardLoadingSkeleton = () => {
  return (
    <LoaderContainer>
      <ImageLoadingBox />
      <Group direction="vertical" gap={4}>
        <TagsLoadingBox />
        <TextLoadingBox typography="caption-large" width="100%" />
      </Group>
      <TextLoadingBox typography="heading6" width="100%" />
      <TextLoadingBox typography="caption-small" width={80} />
      <Group direction="vertical" gap={16}>
        <ReviewsLoadingBox />
        <TextLoadingBox typography="caption-large" width={32} />
      </Group>
      <TextLoadingBox typography="heading4" width={95} />
      <Group direction="horizontal" horizontalAlign="space-between">
        <div>
          <PricingLoadingBoxTop />
          <PricingLoadingBoxBottom />
        </div>
        <ViewButtonLoadingBox />
      </Group>
    </LoaderContainer>
  )
}
